<template lang="pug">
  p(:class="banner_bg").Banner.p-1.text-sm.transition.font-bold.rounded-bd-small.py-0.cursor-pointer
    small(:class="banner_text")
      slot
</template>

<script>
export default {
  name: "Banner",
  props: {
    banner_text: {
      default: "text-secondary",
      type: String,
    },
    banner_bg: {
      default: "background-primary",
      type: String,
    },
  },
}
</script>

<style scoped>
.background-primary {
  background: #aac4f748;
  width: fit-content;
}
</style>